var MiniCart = class {

    mod = 5;

    constructor(selector){
        this.minicart = jQuery(selector);
        this._init();
    };

    _init(){
        var instance = this;
        this.minicart.on('removedFromMinicart', (function(event){
            this._redrawMinicart(event.cart);
        }).bind(instance));

        this.minicart.on('updateMiniCart', (function(){
            this.redrawAjaxCart()
        }).bind(this));

        this.redrawAjaxCart();

        this.minicart.find('.prev-page').click((this.prev_page).bind(this));
        this.minicart.find('.next-page').click((this.next_page).bind(this));
    }

    redrawAjaxCart(){
        $.getJSON('/cart.js').then((this._redrawMinicart).bind(this));
    }

    _redrawMinicart(cart) {
        this.current_cart = cart;

        jQuery('[data-cart-count]').text(cart.item_count);

        this.minicart.find('.total-item-count').text(cart.item_count + (cart.item_count == 1 ? ' ARTICOLO' : ' ARTICOLI'));

        var total_price = cart.total_price;
        total_price = total_price/100.00;
        this.minicart.find('.mc-total').text(total_price.toFixed(2));

        // raggruppiamo gli articoli in base alla tipologia
        this.capsule = cart.items.filter(it => it.product_type == 'capsule');
        this.macchine = cart.items.filter(it => it.product_type == 'macchine');
        this.accessori = cart.items.filter(it => it.product_type == 'accessori');
        this.bundle = cart.items.filter(it => it.product_type == 'bundle');
        this.giftCards = cart.items.filter(it => it.product_type == 'giftcard');


        this._drawMacchineSection(this.macchine);
        this._drawCapsuleSection(this.capsule);
        this._drawAccessoriSection(this.accessori);
        this._drawBundleSection(this.bundle);
        this._drawGiftCardSection(this.giftCards);

        this._drawEmptyCart(cart.items.length == 0);

        this._manageCheckoutButton();
    }

    _drawEmptyCart(isEmpty) {
        if (isEmpty) {
            this.minicart.addClass('emptyCart');
        } else {
            this.minicart.removeClass('emptyCart');
        }
    }

    _drawMacchineSection(items){
        var container = this.minicart.find('.macchine-container');
        if (items.length == 0) {
        	container.hide();
            return;
        }
        
        container.show();
        var overview = container.find('.macchine-overview');

        // resettiamo eventuali elementi già presenti
        overview.find('.grid-container').remove();

        // inseriamo tutti gli elementi
        var gridContainer = jQuery('<div class="row grid-container py-2"></div>');
        for (var i = 0; i < items.length; i++){
            var item = this._buildCartItem(items[i]);
            gridContainer.append(item);
        }

        overview.append(gridContainer);
    }

    _drawCapsuleSection(items) {
        var container = this.minicart.find('.capsule-container');
        if (items.length == 0) {
        	container.hide();
            return;
        }

        container.show();
        var overview = container.find('.capsule-overview');

        // resettiamo eventuali elementi già presenti
        overview.find('.grid-container').remove();

        // inseriamo tutti gli elementi
        var gridContainer = jQuery('<div class="row grid-container py-2"></div>');
        for (var i = 0; i < items.length; i++){
            var item = this._buildCartItem(items[i]);
            gridContainer.append(item);
        }

        overview.append(gridContainer);
    }

    _drawAccessoriSection(items) {
        var container = this.minicart.find('.accessori-container');
        if (items.length == 0) {
        	container.hide();
            return;
        }

        container.show();
        var overview = container.find('.accessori-overview');

        // resettiamo eventuali elementi già presenti
        overview.find('.grid-container').remove();

        // inseriamo tutti gli elementi
        var gridContainer = jQuery('<div class="row grid-container py-2"></div>');
        for (var i = 0; i < items.length; i++){
            var item = this._buildCartItem(items[i]);
            gridContainer.append(item);
        }

        overview.append(gridContainer);
    }

    _drawBundleSection(items) {
        var container = this.minicart.find('.bundle-container');
        if (items.length == 0) {
        	container.hide();
            return;
        }

        container.show();
        var overview = container.find('.bundle-overview');

        // resettiamo eventuali elementi già presenti
        overview.find('.grid-container').remove();

        // inseriamo tutti gli elementi
        var gridContainer = jQuery('<div class="row grid-container py-2"></div>');
        for (var i = 0; i < items.length; i++){
            var item = this._buildCartItem(items[i]);
            gridContainer.append(item);
        }

        overview.append(gridContainer);
    }

    _drawGiftCardSection(items) {
        var container = this.minicart.find('.giftcard-container');
        if (items.length == 0) {
        	container.hide();
            return;
        }

        container.show();
        var overview = container.find('.giftcard-overview');

        // resettiamo eventuali elementi già presenti
        overview.find('.grid-container').remove();

        // inseriamo tutti gli elementi
        var gridContainer = jQuery('<div class="row grid-container py-2"></div>');
        for (var i = 0; i < items.length; i++){
            var item = this._buildCartItem(items[i]);
            gridContainer.append(item);
        }

        overview.append(gridContainer);
    }
  
    _buildCartItem(item){
        if (!item) {
            return null;
        }

        var template = "\
        <div class=\"col-sm-12 px-0 d-flex minicart-item-overview minicart-item-overview-template\">\
            <div class=\"minicart-item-img\">\
                <a href=\"[[productUrl]]\" aria-label=\"Vai alla scheda del prodotto\">\
                <img class=\"minicart_product_image\" src=\"[[productImageUrl]]\" width=\"30px\" alt=\"\" aria-hidden=\"true\">\
                </a>\
            </div>\
            <div class=\"minicart-item-info\">\
                <div class=\"item-name\">[[productTitle]]</div> \
                <div class=\"d-flex minicart_quantity quantity\">\
                    <input aria-label=\"Quantità prodotto\" type=\"number\" class=\"minicart_input_qty\" id=\"minicart-item-quantity\" value=\"[[productQuantity]]\" min=\"0\" pattern=\"[0-9]*\" onchange=\"\">\
                </div>\
            </div>\
            <div class=\"minicart-item-price text-right\">\
                <div class=\"minicart_product_price\">[[productPrice]]</div>\
            </div>\
        </div>\
        ";

        var priceInEuro = item.price/100.00;

        template = template
            .replace('[[productUrl]]', item.url)
            .replace('[[productTitle]]', item.title)
            .replace('[[productPrice]]', '&euro;' + priceInEuro.toFixed(2))
            .replace('[[productQuantity]]', item.quantity)
            .replace('[[productImageUrl]]', item.image);

        // button per rimuovere il singolo item
        var removeButton = jQuery('<a href="#null" class="item-remove-btn" aria-label="Rimuovi il prodotto dal carrello">Rimuovi</a>');
        removeButton.click({variant_id: item.variant_id }, (this._removeItem).bind(this));
        
        var inputAddQuantity = jQuery('<div class="minicart-quantity-button quantity-up" aria-label="Aumenta quantità">+</div>');
        inputAddQuantity.click({variant_id: item.variant_id }, (this._increaseQuantity).bind(this));
        var inputRemoveQuantity = jQuery('<div class="minicart-quantity-button quantity-down" aria-label="Riduci quantità">-</div>');
        inputRemoveQuantity.click({variant_id: item.variant_id }, (this._decreaseQuantity).bind(this));

        var final = jQuery(template);
        var priceWrapper = final.children('.minicart-item-price').children('.minicart_product_price');
        removeButton.insertAfter(priceWrapper);

        var quantityWrapper = final.children('.minicart-item-info').children('.minicart_quantity');
        quantityWrapper.prepend(inputAddQuantity);
        quantityWrapper.append(inputRemoveQuantity);

        return final;
    }

    // Gestisce la pagina attiva
    _showActivePage(container, numPages){
        var currPageEl = container.find('.current-page');
        var currPageIndex = currPageEl.text();
        // Se non e' inizializzata la current page
        if(currPageIndex.trim() === ""){
            // La pagina attiva e' l'ultima
            currPageIndex = numPages;
        }
        else{
            // Altrimenti se il numero di pagine totali e' < dell'indice della current page
            // ultima pagina diventa la current page
            currPageIndex = parseInt(currPageIndex);
            if(currPageIndex > numPages){
                currPageIndex = numPages;
            }
        }
        if(currPageIndex===0){
          currPageIndex=1;
        }
        // Imposto l'indice della current page
        currPageEl.text(currPageIndex);
        // Mostro la current page
        container.find('.gc-'+currPageIndex).removeClass('d-none');
    }

    _manageCheckoutButton(){
        var enableCheckout = true;
        var capsuleContainer = this.minicart.find('.capsule-container');

        this.minicart.find('.mc-subtotal-container a').show();

        if (this.macchine.length > 2) { // MAX 2 Macchine caffè
            enableCheckout = false;
        }

        if (enableCheckout) {
            jQuery('.mc-submit-btn').attr('href','/cart');
        }
        else{
            jQuery('.mc-submit-btn').removeAttr('href');
        }
    }

    _removeItem(evt) {
        var items = this.current_cart.items.filter(item => item.variant_id == evt.data.variant_id);
        if (items.length == 0) {
            return;
        }
        var item = items[0];
        this._updateQuantity(item, 0, items);
    }

    _increaseQuantity(evt) {
        var items = this.current_cart.items.filter(item => item.variant_id == evt.data.variant_id);
        if (items.length == 0) {
            return;
        }
        var item = items[0];
        var quantity =  parseInt(item.quantity + 1);
        this._updateQuantity(item, quantity, items);
    }

    _decreaseQuantity(evt) {
        var items = this.current_cart.items.filter(item => item.variant_id == evt.data.variant_id);
        if (items.length == 0) {
            return;
        }
        var item = items[0];
        var quantity =  parseInt(item.quantity - 1);
        this._updateQuantity(item, quantity, items);
    }

    _updateQuantity(item, quantity, items) {
        if (!item) {
            return;
        }

        try {
            // creiamo il paylod per aggiornare la quantità
            var updates = {};
            updates[item.variant_id] = quantity;
            
            var params = {
              url: '/cart/update.js',
              data: {
                updates: updates
              },
              dataType: 'json'
            };

            $.post(params)
            .done(function(cart) {
                // se la quantità è zero, rimuoviamolo
                if (quantity == 0) {
                    items.shift();
                }

                jQuery('.minicart').trigger({
                    type: 'removedFromMinicart',
                    cart: cart
                });
            })
            .fail(function(err){
                console.log(err);
            });
        }
        catch(e){
            console.log(e);
        }
    }

    prev_page(){
        var currentPage = this.minicart.find('.capsule-overview .grid-container').not('.d-none');
        var prevPage = currentPage.prevAll('.grid-container');

        if(prevPage.length > 0){

            prevPage = prevPage.first();

            currentPage.addClass('d-none');
            prevPage.removeClass('d-none');

            try{
                var currPageIndex = this.minicart.find('.current-page');
                currPageIndex.text(parseInt(currPageIndex.text())-1);
            }
            catch(e){
                console.log(e);
            }
        }
    }

    next_page(){

        var currentPage = this.minicart.find('.capsule-overview .grid-container').not('.d-none');
        var nextPage = currentPage.nextAll('.grid-container');

        if(nextPage.length > 0){

            nextPage = nextPage.first();

            currentPage.addClass('d-none');
            nextPage.removeClass('d-none');

            try{
                var currPageIndex = this.minicart.find('.current-page');
                currPageIndex.text(parseInt(currPageIndex.text())+1);
            }
            catch(e){
            console.log(e);
            }
        }
    }
}

class FooterMiniCart extends MiniCart {

    _drawCapsuleSection(items){
        var capsuleContainer = this.minicart.find('.capsule-container-footer');
        if (capsuleContainer.length > 0) {
            var length = items.length;
            if (length%this.mod > 0) {
                length += (this.mod-length%this.mod); // rende la lunghezza multipla del modulo
            }
            capsuleContainer.find('.tot-pages').text(length/this.mod);
            // svuoto il wrapper
            jQuery(".contacapsule-wrapper").html("");
            var containerContaCapsule = jQuery(".contacapsule-wrapper");
            var itemSubtotal = 0;
            // loop su tutti gli articoli (il totale è ora multiplo del modulo)
            for (var i = 0; i < length; i++){
                var item = items[i];
                if (item){
                    itemSubtotal += parseInt(item.final_price);
                }
                var itemHtml = this._buildCartItem(item);
                // Aggiungo l'item al suo container
                containerContaCapsule.append(itemHtml);
            }
            // Gestisco la visibilita' dei selettori di pagina

            this.minicart.find('.total-item-count-footer').text(items.length + (items.length == 1 ? ' ARTICOLO' : ' ARTICOLI'));
            this.minicart.find('.mc-subtotal').text((itemSubtotal/100).toFixed(2));
            capsuleContainer.find('.mc-sub-submit-btn').show();
        }
        this.minicart.trigger('minicart-footer-event');
    }

    _buildCartItem(item){
      var extCell=jQuery('<div class="swiper-slide"></div>');
      var cell = jQuery('<div class="footer-cart-item"></div>');


      if(item){

            var imageUrl = '';
            var minicartImages = localStorage.getItem('product_minicart_images');
            if(minicartImages != undefined){
                try{
                    minicartImages = JSON.parse(minicartImages);
                    imageUrl = minicartImages[item.handle];
                }
                catch(e){
                    console.log(e);
                }
            }

            // button per rimuovere il singolo item
            var removeBtn = jQuery('<a href="#null" class="remove-item-btn" aria-label="Rimuovi prodotto dal carrello">×</a>');
            removeBtn.click({variant_id: item.variant_id }, (this._removeItem).bind(this));
            cell.append(removeBtn);
            cell.append('<figure><img src="' + imageUrl + '" ></figure>');
            cell.append('<div class="item-name"><a href=' + item.url + '</a>' +  item.title + '</div>');
            cell.append('</div></div>');
            extCell.append(cell);
      }
      return extCell;

    }
  }

function sessionStoreMinicartImages(handle, imageurl) {
    var sessionImages = localStorage.getItem('product_minicart_images');
    if (sessionImages == undefined) {
        sessionImages = {};
    }
    else {
        sessionImages = JSON.parse(sessionImages);
    }
    sessionImages[handle] = imageurl;

    localStorage.setItem('product_minicart_images', JSON.stringify(sessionImages));
}
